<template>
  <div id="app_content" class="public">
    <div class="container dlds">
      <div class="row">
        <div class="col-md-12">
          <h1 class="my-h1 mb-3 text-capitalize">{{trans.get('public.downloads.title')}}</h1>
        </div>
        <div class="col-lg-3 col-sm-4 mt-5" v-for="(d, i) in downloads" :key="i">
          <card
            :key="i"
            :file_url="d.file_url"
            :id="d.id"
            :media_url="d.media_url"
            :nome_documento="d.nome_documento"
            :nome_file="d.nome_file"
            :nome_media="d.nome_media"
          />
        </div>
      </div>
      <div class="row mt-6">
        <div class="col-md-12">
          <h2>{{trans.get('public.downloads.catalogs')}}</h2>
        </div>
        <div class="col-lg-3 col-sm-4 mt-5">
          <card :media_url="url('/storage/media/copertine_cataloghi/italian.jpg')" nome_documento="Catalogo - IT" nome_file="4belt-it.pdf" :file_url="url('/storage/cataloghi/4belt-it.pdf')"/>
        </div>
        <div class="col-lg-3 col-sm-4 mt-5">
          <card :media_url="url('/storage/media/copertine_cataloghi/english.jpg')" nome_documento="Catalogo - EN" nome_file="4belt-en.pdf" :file_url="url('/storage/cataloghi/4belt-en.pdf')"/>
        </div>
        <div class="col-lg-3 col-sm-4 mt-5">
          <card :media_url="url('/storage/media/copertine_cataloghi/german.jpg')" nome_documento="Catalogo - DE" nome_file="4belt-de.pdf" :file_url="url('/storage/cataloghi/4belt-de.pdf')"/>
        </div>
        <div class="col-lg-3 col-sm-4 mt-5">
          <card :media_url="url('/storage/media/copertine_cataloghi/spanish.jpg')" nome_documento="Catalogo - ES" nome_file="4belt-es.pdf" :file_url="url('/storage/cataloghi/4belt-es.pdf')"/>
        </div>
        <div class="col-lg-3 col-sm-4 mt-5">
          <card :media_url="url('/storage/media/copertine_cataloghi/french.jpg')" nome_documento="Catalogo - FR" nome_file="4belt-fr.pdf" :file_url="url('/storage/cataloghi/4belt-fr.pdf')"/>
        </div>






      </div>
    </div>
    <div class="inner-section newsletter">
      <div class="section-container">
        <div class="my-content">
          <form_newsletter_new />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import card from "./dl-card";
import form_newsletter_new from "./../form-newsletter-new"
export default {
  name: "index",
  components: {
    card,
    form_newsletter_new
  },
  data() {
    return {
      downloads: null,
    };
  },
  mounted() {
    this.getDownloads();
  },
  methods: {
    getDownloads: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/downloads/get",
      }).then((res) => {
        if (res.data.downloads.length > 0) {
          console.log(res.data.downloads);
          this.downloads = res.data.downloads;
        } else {
          this.downloads = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: revert;
  font-weight: normal;
}

#app_content.public {
  background-color: var(--black-2);
  color: #fff;

  .container {

    &.dlds {
      padding: 200px 0;
      @media (max-width: 576px) {
        padding: 100px 0;
      }
    }

  }
}

@media (min-width: 1200px) {
  #app_content.public {
    .container {
      max-width: calc(100% - var(--public-menu-width));
      margin: 0 0 0 var(--public-menu-width);
      &.dlds {
        padding: 100px 0;
      }
    }
  }
}
</style>
